import React from "react" ;
import AdminAppBodyHeader from "./AdminAppBodyHeader";
import {Route, Switch} from "react-router-dom";

import {getAdminRouterPath} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import UsersDashboardTab from "root/Wieldy/ApplicationModules/Users/Body/UserDashboards/UsersDashboardTab";
import DomainsTab from "root/Wieldy/ApplicationModules/Admin/Body/Domains/DomainsTab";
import OrganisationsTab from "root/Wieldy/ApplicationModules/Admin/Body/Organisations/OrganisationsTab";

const AdminAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <AdminAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={getAdminRouterPath('domains')} render={(thisprops) => <DomainsTab {...thisprops}/>}/>
                        <Route path={getAdminRouterPath('organisations')} render={(thisprops) => <OrganisationsTab {...thisprops}/>}/>
                        <Route path={getAdminRouterPath('dashboard')} render={(thisprops) => <UsersDashboardTab {...thisprops}/>}/>
                        <Route path={getAdminRouterPath()} render={(thisprops) => <DomainsTab {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default AdminAppBody;
